import { message } from "antd";
import { EIntegrationPlatform } from "../../models/integrations.model";
import { TConfig } from "../../services/apiWorker";
import { authWikipedia } from "../../services/integrations/wikipedia.service";

export const IntegrationWikipedia = {
  type: EIntegrationPlatform.WIKIPEDIA,
  icon: "/assets/integrations/wikipedia.png",
  title: "Wikipedia",
  description:
    "Direct access to Wikipedia articles and information within your app.",

  openAuth: (config: TConfig) => {
    authWikipedia({
      onSuccess: (data) => {
        message.success("Integration done!");

        PubSub.publish("addIntegration", data);
      },
    });
  },

  AuthRender: () => {
    return <></>;
  },
};
